import { publicTimelinePhaseSchema } from "@/schemas/contracts/publicTimeline";

function byCreated(a, b) {
  return (
    String(a.created_at ?? "").localeCompare(String(b.created_at ?? "")) ||
    a.id.localeCompare(b.id)
  );
}

export function mergePublicPhases(current = [], incoming = []) {
  const phases = new Map(current.map((phase) => [phase.id, phase]));
  incoming.forEach((raw) => {
    const parsed = publicTimelinePhaseSchema.safeParse(raw);
    if (!parsed.success) return;
    const prior = phases.get(parsed.data.id);
    if (!prior || parsed.data.revision >= prior.revision)
      phases.set(parsed.data.id, { ...prior, ...parsed.data });
  });
  return [...phases.values()].sort(byCreated);
}

export function publicProgressPhase(event) {
  if (event?.tool !== "public_progress") return null;
  return publicTimelinePhaseSchema.safeParse(event.payload).success
    ? publicTimelinePhaseSchema.parse(event.payload)
    : null;
}
